import { useMemo } from 'react';
import { TabMainNavProps } from '@sato/components';

import { LANGUAGE_SELECTIONS } from '@components/layout/navigation/MainNavigation/MainNavigation.utils';
import { localizationStore } from '@stores/localization';
import { isValidLanguage } from '@utils/localize.utils';

import { useLanguage, useTranslate } from './useTranslate';

/** Utility hook for providing language selection
 * props for main nav and other components */
export const useLanguageSelection = () => {
  const language = useLanguage();
  const { t } = useTranslate();

  return useMemo(
    () =>
      ({
        label: t('choose_language'),
        'aria-label': t('choose_language'),
        selectedLanguage: language,
        onLanguageSelected: (lang) => {
          if (!isValidLanguage(lang)) return;

          localizationStore.setLanguage(lang);
        },
        languageSelections: LANGUAGE_SELECTIONS,
      }) satisfies TabMainNavProps<'a'>['languageSelection'],
    [language]
  );
};
